import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import React from 'react';

interface SnackbarAlertProps {
  open: boolean;
  message: string;
  handleClose: () => void;
}

function SnackbarAlert({ open, message, handleClose }: SnackbarAlertProps): JSX.Element {
  let displayMessage = ''
  let isSuccess = false
  try {
    message.toLowerCase();
    displayMessage = message;
  } catch {}
  finally {
    isSuccess = displayMessage.toLowerCase().includes('success')
  }

  return (  
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={isSuccess ? 'success' : 'error'}>
        {displayMessage}
      </Alert>
    </Snackbar>
  );
}

export default SnackbarAlert;
